module.exports = __webpack_public_path__ + "img/seeburg_teardrop_logo.01f6d1d2.png";